import { Wallet, CalendarDays, Calculator, LayoutDashboard } from 'lucide-react'
import { PhoneMockup } from '../components/PhoneMockup'
import { RevealWrapper } from '../components/RevealWrapper'

interface Feature {
  icon: React.ElementType
  tag: string
  title: string
  subtitle: string
  screen: string
  dark: boolean
  rotate: number
}

const FEATURES: Feature[] = [
  {
    icon: Wallet,
    tag: 'Controle Financeiro',
    title: 'Adeus, inadimplência invisível.',
    subtitle: 'Quem pagou, quem deve, quanto entrou — tudo visível sem planilha nenhuma.',
    screen: '/images/IMG_6482.PNG',
    dark: false,
    rotate: -2, //comentario para subir atualização
  },
  {
    icon: CalendarDays,
    tag: 'Agenda de Serviços',
    title: 'Organização que cabe no bolso.',
    subtitle: 'Serviço, área e piloto. Tudo em 2 toques, mesmo sem sinal no campo.',
    screen: '/images/IMG_6472.PNG',
    dark: true,
    rotate: 2,
  },
  {
    icon: LayoutDashboard,
    tag: 'Dashboard de Operação',
    title: 'Visão geral em tempo real.',
    subtitle: 'Clima, faturamento acumulado e próximas operações. Numa tela só.',
    screen: '/images/IMG_6473.PNG',
    dark: false,
    rotate: -3,
  },
  {
    icon: Calculator,
    tag: 'Calculadora de calda',
    title: 'Calcule com precisão sem sair do app.',
    subtitle: 'Com a calculadora de calda integrada, obtenha as proporções exatas para cada serviço, garantindo eficiência e resultados consistentes.',
    screen: '/images/IMG_6469.PNG',
    dark: true,
    rotate: 2,
  },
]

export function FeaturesSection() {
  return (
    <section
      aria-labelledby="features-heading"
      style={{ padding: '72px 24px', maxWidth: 480, margin: '0 auto' }}
    >
      <RevealWrapper>
        <h2
          id="features-heading"
          style={{
            fontFamily: 'var(--font-bricolage)',
            fontSize: 'clamp(24px, 7vw, 30px)',
            fontWeight: 800,
            lineHeight: 1.18,
            letterSpacing: '-0.025em',
            marginBottom: 8,
            textAlign: 'center',
          }}
        >
          Tudo que você precisa.
          <br />Nada que você não usa.
        </h2>
        <p
          style={{
            fontSize: 14,
            color: '#6A675E',
            textAlign: 'center',
            lineHeight: 1.7,
            marginBottom: 44,
          }}
        >
          Feito para operadores solo. Sem funcionalidades desnecessárias.
        </p>
      </RevealWrapper>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
        {FEATURES.map((f, i) => {
          const Icon = f.icon
          return (
            <RevealWrapper key={i} delay={0.06} className="card-lift">
              <div
                style={{
                  background: f.dark ? '#0B1D11' : '#fff',
                  borderRadius: 28,
                  padding: '30px 26px 0',
                  border: f.dark ? 'none' : '1px solid #EDE9E1',
                  boxShadow: f.dark ? 'none' : '0 2px 16px rgba(0,0,0,0.05)',
                  overflow: 'hidden',
                  position: 'relative',
                }}
              >
                {f.dark && (
                  <div
                    aria-hidden
                    style={{
                      position: 'absolute',
                      top: -60, right: -60,
                      width: 240, height: 240,
                      background: 'radial-gradient(circle, rgba(82,201,126,0.1) 0%, transparent 70%)',
                      pointerEvents: 'none',
                    }}
                  />
                )}

                <div
                  style={{
                    width: 40, height: 40,
                    borderRadius: 12,
                    background: f.dark ? 'rgba(82,201,126,0.12)' : '#EEF8F2',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    marginBottom: 16,
                  }}
                >
                  <Icon size={20} color={f.dark ? '#52C97E' : '#1A5C2E'} strokeWidth={1.8} />
                </div>

                <span
                  style={{
                    display: 'inline-block',
                    padding: '3px 10px',
                    borderRadius: 999,
                    background: f.dark ? 'rgba(82,201,126,0.1)' : '#EEF8F2',
                    color: f.dark ? '#52C97E' : '#1A5C2E',
                    fontSize: 10,
                    fontWeight: 700,
                    letterSpacing: '0.05em',
                    textTransform: 'uppercase',
                    marginBottom: 14,
                  }}
                >
                  {f.tag}
                </span>

                <h3
                  style={{
                    fontFamily: 'var(--font-bricolage)',
                    fontSize: 22,
                    fontWeight: 800,
                    color: f.dark ? '#fff' : '#0A1A10',
                    lineHeight: 1.18,
                    letterSpacing: '-0.022em',
                    marginBottom: 10,
                  }}
                >
                  {f.title}
                </h3>

                <p
                  style={{
                    fontSize: 14,
                    color: f.dark ? 'rgba(255,255,255,0.5)' : '#6A675E',
                    lineHeight: 1.65,
                    marginBottom: 30,
                  }}
                >
                  {f.subtitle}
                </p>

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    paddingTop: 8,
                    marginBottom: -8,
                  }}
                >
                  <PhoneMockup
                    src={f.screen}
                    alt={`Tela de ${f.tag} no DroneOps`}
                    rotate={f.rotate}
                    width={210}
                  />
                </div>
              </div>
            </RevealWrapper>
          )
        })}
      </div>
    </section>
  )
}
